// ---------------------------------------------------------------
// Family/shared-viewer ↔ car linking with OWNER APPROVAL. Requests live on the
// device itself (Traccar attributes.memberLinks) so they sync between the member
// and the owner (both read the same device via the shared token). A member
// entering a car's share code creates a PENDING request; the owner must approve
// before the car shows in the member's fleet. Approved members get full view.
// ---------------------------------------------------------------
import { updateDevice } from './traccar';

export const getMemberLinks = (d) => ((d && d.attributes && d.attributes.memberLinks) || []);

// 'pending' | 'approved' | 'declined' | null
export function memberLinkStatus(d, memberId) {
  const l = getMemberLinks(d).find((x) => x.memberId === memberId);
  return l ? l.status : null;
}

export const pendingMemberLinks = (d) => getMemberLinks(d).filter((x) => x.status === 'pending');
export const approvedMemberLinks = (d) => getMemberLinks(d).filter((x) => x.status === 'approved');

// A logged-in owner/customer can ALSO add another family member's car by code.
// Build a stable member identity from their Traccar user so requests/approvals
// work exactly like a /family account. `me` = getStoredMe().
export function shareIdentity(me) {
  if (!me) return null;
  return { id: `u${me.id}`, name: me.name || me.email || 'Me', email: me.email || '' };
}
// devices this identity has been approved to view (their shared cars)
export const approvedForMember = (devices, memberId) => (devices || []).filter((d) => memberLinkStatus(d, memberId) === 'approved');

// member asks to add this car → pending (replaces any prior entry for them)
export async function requestMemberLink(device, member) {
  const links = getMemberLinks(device).filter((x) => x.memberId !== member.id);
  links.push({
    memberId: member.id,
    memberName: member.name || member.email,
    memberEmail: member.email || '',
    at: new Date().toISOString(),
    status: 'pending',
  });
  const updated = { ...device, attributes: { ...(device.attributes || {}), memberLinks: links } };
  await updateDevice(updated);
  return updated;
}

// owner decision (or revoke): status = 'approved' | 'declined'
export async function setMemberLinkStatus(device, memberId, status) {
  const links = getMemberLinks(device).map((x) => (x.memberId === memberId ? { ...x, status, decidedAt: new Date().toISOString() } : x));
  const updated = { ...device, attributes: { ...(device.attributes || {}), memberLinks: links } };
  await updateDevice(updated);
  return updated;
}

// remove a link entirely (member unlinks, or owner removes)
export async function removeMemberLink(device, memberId) {
  const links = getMemberLinks(device).filter((x) => x.memberId !== memberId);
  const updated = { ...device, attributes: { ...(device.attributes || {}), memberLinks: links } };
  await updateDevice(updated);
  return updated;
}
